import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import useCodingQueueFilterService from '../../../../modules/hooks/usecodingqueuefilterservice';

const Filter = ({ service }) => {
  const [state, boundActions] = useCodingQueueFilterService(service);

  const {
    isFailedInit,
    isLoading,
    contractsDropdownState
  } = state;

  const history = useHistory();

  if (isFailedInit) return (<div><h3>Error, please refresh page</h3></div>);

  return (
    <div>
      <div>
        <h3>ACA Coding Queue Filter</h3>
      </div>

      <div style={{ display: 'inline-block' }}>
        <select
          onChange={boundActions.setSelectedContract}
          value={contractsDropdownState.selectedItem}
        >
          <option value="-1">Choose a Contract</option>
          {
            contractsDropdownState.items.map(x => (
              <option
                key={x.value}
                value={x.value}
              >
                {x.label}
              </option>
            ))
          }
        </select>
      </div>

      <div style={{ display: 'inline-block' }}>
        <button
          disabled={isLoading || contractsDropdownState.selectedItem == '-1'}
          onClick={() => boundActions.doBeginWork(
            contractsDropdownState.selectedItem,
            history.push
          )}
        >
          <span>Begin Work</span>
        </button>
      </div>
    </div>
  );
};

Filter.propTypes = {
  service: PropTypes.shape({
    init: PropTypes.func.isRequired,
    beginWork: PropTypes.func.isRequired,
    serviceRoutes: PropTypes.shape({
      init: PropTypes.string.isRequired,
      beginWork: PropTypes.string.isRequired
    }).isRequired
  }).isRequired
};

export default Filter;
